import Dictionary from "@/types/Dictionary";
import { Vue } from 'vue-property-decorator';
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import axios from "axios";
import { API_URL } from "@/App.settings";
import ShareItem from "@/types/ShareItem";

/** Store VueX pour la gestion de la fonctionnalité de partage d'éléments */
@Module({
    namespaced: false
})
class ShareStore extends VuexModule{
    /** Liste des éléments à partager */
    private sharableItems: ShareItem[] = [];

//#region Mutations
    @Mutation
    private setShareItems(sharableItems: ShareItem[]){
        this.sharableItems = [];

        for (let sharableItem of sharableItems) {
            this.sharableItems.push(new ShareItem( sharableItem.Id, sharableItem.Label, sharableItem.ShareType, sharableItem.Share));
        }

        console.debug("ShareStore - setShareItems - sharableItems", this.sharableItems);
    }

    /** Réinitisation du store VueX */
    @Mutation
    private reset() {
        this.sharableItems = [];
    }
//#endRegion Mutations

//#region Actions
    /**
     * Récupération de la liste des élements partageables selon le type d'élément
     */
    @Action({ rawError: true })
    public async LoadSharableItems(){
        const args: Dictionary<any> = {};

        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

        await axios.post<ShareItem[]>(API_URL + "/Share/LoadSharableItems", args).then(async (response) => {
            console.debug("ShareStore - LoadSharableItems - response", response);
            await this.context.commit('setShareItems', response.data);
        });
    }

    /**
     * Permet le partage d'un élément
     * @param shareItem objet des éléments à partager
     */
    @Action({rawError: true})
    public async Share(shareItem : {shareType: string, shareIds: string[], userIds: Dictionary<any>, forcedShare : boolean}){
        const args: Dictionary<any> = {};

        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["ShareType"] = shareItem.shareType;
        args["ShareIds"] = shareItem.shareIds;
        args["UserIds"] = shareItem.userIds;
        args["ForcedShare"] = shareItem.forcedShare;

        await axios.post(API_URL + "/Share/ActionShare", args)
    }

    /**
     * Met à jour l'élément en attente de partage
     * @param shareItem objet en attente de partage
     */
    @Action({rawError: true})
    public async UpdateShareItem({ id, accept, shareType }){
        const args: Dictionary<any> = {};

        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["Id"] = id
        args["ShareType"] = shareType;
        args["Accept"] = accept;

        await axios.post(API_URL + "/Share/UpdateShareItem", args).then(async () => {
            console.debug("ShareStore - UpdateShareItem !");
            await this.context.dispatch("LoadSharableItems", shareType);
        });
    }

    /** Réinitialisation du store VueX */
    @Action({rawError: true})
    public Reset() {
        this.context.commit("reset");
    }
//#endregion Actions

//#region Getters
    /** retourne la liste des liste des choix de partage */
    public get GetSharableItems(): ShareItem[] {
        console.debug("ShareStore - GetSharableItems - sharableItems", this.sharableItems);
        
        return this.sharableItems;
    }
//#endregion
}

export default ShareStore;